import type { AxiosError } from 'axios';
import { reactive, ref } from 'vue';

export function createState() {
  return reactive({
    onErrorClb: ref<Record<number, (error: AxiosError) => void>>(Object.create(null)),
  });
}
